import React from "react";
import useLoading from "../../CommonComponent/useLoading";
import Loader from "../../Loader/Loader";
import www from "../Examination/GradeCard/www.png";

const SalarySlipCard = (props) => {
  const { userData, id, base64Image, loading, totalDays, salaryDate } = props;

  console.log(userData, "././././././././././././././././././.");
  const lossCalculator = () => {
    const absentDays = userData.presenty.absent;
    const gross = userData.gross;
    const avalabledays = 30;
    const leavesCut = (gross / avalabledays) * absentDays;
    return Math.round(leavesCut);
  };

  // {
  //     "id": 1202,
  //     "fk_attendance_month_id": 415,
  //     "fk_staff_id": 494,
  //     "fk_staff__first_name": "Ketan",
  //     "fk_staff__last_name": "Hundai",
  //     "fk_staff__emp_no": "TEMM00003",
  //     "fk_staff__joining_date": "2024-07-19",
  //     "fk_staff__pan_no": "",
  //     "presenty": {
  //         "494": 494,
  //         "absent": 6,
  //         "present": 25
  //     },
  //     "earning": [
  //         {
  //             "heads_name": "ascasc",
  //             "staffId": 494,
  //             "heads_type": "Earning",
  //             "amount": 40323,
  //             "is_manual": false,
  //             "is_active": true,
  //             "is_fixed": false,
  //             "sequence": "1"
  //         }
  //     ],
  //     "deduction": [],
  //     "gross": "40323",
  //     "total_deduction": "0",
  //     "net": "40323",
  //     "created_date": "2025-07-22",
  //     "fk_staff__fk_school__name": "Tirpude Junior College",
  //     "fk_staff__fk_school__address": "cascasc",
  //     "fk_staff__fk_school__pincode": "440013",
  //     "fk_staff__fk_school__contact_number": "7770077700",
  //     "fk_staff__fk_school__contact_email": "jeveweb961@dxice.com",
  //     "fk_staff__fk_designation__value": "Teacher",
  //     "fk_staff__gender": "Male",
  //     "fk_staff__leaving_date": null,
  //     "fk_staff__fk_school__fk_organization__name": "FiPal Technologies",
  //     "fixedEarningsTotal": 0
  // }

  if (loading) return <Loader />;
  return (
    <div className="salary-slip-card container" id={id} key={id}
         style={{
    pageBreakAfter: "always",   // force a page break after each slip
    breakAfter: "page",
    pageBreakInside: "avoid",   // avoid splitting the card across pages
    breakInside: "avoid",
  }}
    >
      <div className="Wholeborder p-0">
        <div></div>
        <div className="salary-slip">
          <div className="d-flex ">
            <div className="col-3 m-auto">
              {base64Image ? (
                <img
                  src={`data:image/png;base64,${base64Image}`}
                  alt="school_logo"
                  width={100}
                  height={100}
                  className=""
                  style={{ borderRadius: "50%" }}
                />
              ) : (
                <img
                  src={www}
                  alt="fallback_image"
                  width={100}
                  height={100}
                  style={{ borderRadius: "50%" }}
                />
              )}
            </div>

            {/* Column for the text in the center */}
            <div className="col-9">
              <div className="text-center col-8">
                {/* <div
                  className="font-weight-bold text-dark"
                  style={{ fontSize: "10px" }}
                >
                  {userData?.fk_staff__fk_school__fk_organization__name}
                </div> */}
                <div className="font-weight-bold" style={{ fontSize: "13px" }}>
                  {userData?.fk_staff__fk_school__name}
                </div>
                <div>
                  <div style={{ fontSize: "11px" }}>
                    {userData.fk_staff__fk_school__address}{" "}
                  </div>
                  <div style={{ fontSize: "11px" }}>
                    Pincode- {userData.fk_staff__fk_school__pincode}, Ph:{" "}
                    {userData.fk_staff__fk_school__contact_number}
                  </div>
                  <div style={{ fontSize: "11px" }}>
                    E-mail: {userData.fk_staff__fk_school__contact_email}
                  </div>
                </div>
                <div className="font-weight-bold">
                  <div className="text-center">
                    Payslip for The Month of {salaryDate}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="rlborder"
        style={{
          background: "lightgrey",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          className="text-center"
          style={{ marginBlock: "auto", fontWeight: "bold", padding: "0px" }}
        >
          Associate Information
        </div>
      </div>

      <div className="rlborder">
        <div className="row">
          <div className="col-12" style={{ marginLeft: "1px" }}>
            <div className="">
              {" "}
              <table className="salary-slip-table" style={{ padding: "0px" }}>
                <tbody>
                  <tr>
                    <td className="label col-3">Associate Id</td>
                    <td className="value col-3">{userData.fk_staff__emp_no}</td>

                    <td className="label col-3">PAN</td>
                    <td className="NewValues col-3">{userData.fk_staff__pan_no}</td>
                  </tr>

                  <tr>
                    <td className="label col-3">Employee Name</td>
                    <td className="value col-3">
                      {userData.fk_staff__first_name +
                        " " +
                        userData.fk_staff__last_name}
                    </td>

                    <td className="label col-3">Leaving Date</td>
                    <td className="NewValues col-3">
                      {userData?.fk_staff__leaving_date || " "}
                    </td>
                  </tr>
                  <tr>
                    <td className="label col-3">Designation</td>
                    <td className="value col-3">
                      {userData.fk_staff__fk_designation__value}
                    </td>

                    <td className=" label col-4">Available Calendar Days</td>
                    <td className=" NewValues col-2">{totalDays}</td>
                  </tr>
                  <tr>
                    <td className="label col-3">Gender</td>
                    <td className="value col-3">{userData.fk_staff__gender}</td>

                    <td class=" label col-3">Paid Days</td>
                    <td className="NewValues col-3">
                      {userData?.presenty?.present}
                    </td>
                  </tr>
                  <tr>
                    <td className="label col-3">Date of Joining</td>
                    <td className="value col-3">
                      {userData.fk_staff__joining_date}
                    </td>
                    <td className=" label col-3">Loss of Pay Days</td>
                    <td className="NewValues col-3">
                      {userData?.presenty?.absent || 0}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6 " style={{ padding: "0px 0px 0px 4px" }}>
            <div
              className="ml-1 d-flex justify-content-between"
              style={{ background: "lightgrey", borderTop: "2px solid black" }}
            >
              <h6
                className="m-auto text-dark font-bold"
                style={{ fontSize: "12px", padding: "1px" }}
              >
                Earnings
              </h6>
              <h6
                className="m-auto text-dark font-bold"
                style={{ fontSize: "12px", padding: "1px" }}
              >
                Amount
              </h6>
            </div>
            <div className="Boder"></div>
            <div className="" style={{ padding: "0px" }}>
              <table className="table-custom">
                <tbody>
                  {userData &&
                    userData.earning?.map((s, index) => (
                      <tr key={index}>
                        <td
                          className="label col-3 text-wrap"
                          style={{ fontSize: "13px" }}
                        >
                          {s.heads_name}
                        </td>
                        <td className="value col-3">{s.amount}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-6 Bleft " style={{ padding: "0px 5px 0px 0px" }}>
            <div
              className="mr-1 d-flex justify-content-between"
              style={{ background: "lightgrey", borderTop: "2px solid black" }}
            >
              <h6
                className="m-auto text-dark font-bold"
                style={{ fontSize: "12px", padding: "1px" }}
              >
                Deductions
              </h6>
              <h6
                className="m-auto text-dark font-bold"
                style={{ fontSize: "12px", padding: "1px" }}
              >
                Amount
              </h6>
            </div>
            <div className="Boder mr-1"></div>
            <div className="">
              <table className="table-custom">
                <tbody>
                  {userData &&
                    userData.deduction?.map((s, index) => (
                      <tr key={index}>
                        <td
                          className="label col-3 text-wrap"
                          style={{ marginRight: "10px", fontSize: "13px" }}
                        >
                          {s.heads_name}
                        </td>
                        <td className="value col-3">{s.amount}</td>
                      </tr>
                    ))}
                </tbody>
                {/* <tr>
                  <td class=" label col-3">Loss of Pay Days</td>
                  <td class="value col-3">{lossCalculator()}</td>
                </tr> */}
              </table>
            </div>
          </div>
        </div>

        <div className="Boder1"></div>
        <div className="row">
          <div className="col-6 p-0">
            <table className="customTable1">
              <tbody>
                <tr>
                  <td className="label" style={{ paddingLeft: "8px" }}>
                    (A) Total Earning
                  </td>
                  <td className="value">{userData?.gross}</td>
                </tr>
              </tbody>
            </table>

            {/* <div className="Boder ml-2"></div> */}
            {/* <table className="table-custom">
              <tbody>
                <tr>
                  <td className=" label">
                    Fix Earning
                  </td>
                  <td className="value">
                    {userData?.fixedEarningsTotal || 0}
                  </td>
                </tr>
              </tbody>
            </table> */}
          </div>
          <div className="col-6 Bleft p-0">
            <table className="customTable1">
              <tbody>
                <tr>
                  <td className="label">(B) Total Deduction</td>
                  <td className="value ">{Number(userData?.total_deduction)}</td>
                </tr>
              </tbody>
            </table>

            <div className="Boder mr-2"></div>
            <table className="customTable1">
              <tbody>
                <tr>
                  <td className="label">Net Salary = (A)-(B)</td>
                  <td className="value">{userData?.net }</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="Boder1"></div>
        <div className="row">
          <div className="col-6">
            <div
              className="text-capitalize font-weight-bold"
              style={{ fontSize: "12px" }}
            >
              {/* In Word <span className="mx-2">:</span> {words} */}
            </div>
            <div className="mx-2 mt-2">
              {" "}
              <div className="">Report Generated Details</div>
              <div className=" font-weight-bold">
                Date <span className="mx-2">:</span>
                {userData?.created_date}
              </div>
            </div>
          </div>
          <div className="col-6">
            <p className="p-3 text-capitalize font-weight-bold text-right mx-5 my-1">
              Seal
            </p>
          </div>
        </div>
        <div>
          <p className="text-center text-dark font-weight-bold">
            This is a Computer Generated Copy , Seal & Signature is not Required
          </p>
        </div>
      </div>
    </div>
  );
};

export default SalarySlipCard;
